import React, {useState} from 'react'
import FlagUa from "../../../assets/img/flag-uk.svg";
import FlagEn from "../../../assets/img/flag-english.svg";
import Popover from "@material-ui/core/Popover";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {useTranslation} from 'react-i18next';
import IconButton from "@material-ui/core/IconButton";

const LangToIcon = {ua: FlagUa, en: FlagEn/*, ru: FlagRu*/}
const LangToTitle = {ua: "Українська", en: "English"/*, ru: "Русский"*/}

const FlagIcon = ({lang = 'ua'}) => {
  const setFlagIcon = LangToIcon.hasOwnProperty(lang) ? LangToIcon[lang] : FlagUa

  return (
      <div className='flag'><img src={setFlagIcon} alt=""/></div>
  )
}

const LanguageSelector = () => {

  const { i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng)
  }

  const [anchorEl, setAnchorEl] = useState(null)
  const langOpen = Boolean(anchorEl)

  const handleLangMenuClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleLangMenuClose = () => {
    setAnchorEl(null)
  }

  const setLang = lang => {
    changeLanguage(lang)
    handleLangMenuClose()
  }

  const currentLng = i18n.language
  return (
    <div className='languageSelector'>
      <IconButton
        onClick={handleLangMenuClick}
        size='small'
        disableRipple={true}
      >
        <FlagIcon lang={currentLng} />
      </IconButton>

      <Popover
        open={langOpen}
        anchorEl={anchorEl}
        onClose={handleLangMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        disableScrollLock={true}
      >
        <List component="nav" aria-label="main mailbox folders" className='popoverMenu'>
          {Object.keys(LangToIcon).map(lang => {
            return (
                <ListItem key={`lang_icon_${lang}`} button onClick={() => setLang(lang)}>
                  <ListItemIcon>
                    <FlagIcon lang={lang} />
                  </ListItemIcon>
                  <ListItemText primary={LangToTitle[lang]} />
                </ListItem>
            )
          })}
        </List>
      </Popover>
    </div>
  )
}

export default LanguageSelector